import type { BasicSuccessResponse, HTTPFunctions, ProfileUsersToShareResponse, SetTargetUsersToShareRequest } from '../types';
import type { CustomizedTarget, CustomizedTargetResponse, CustomizedTargetWithId } from 'pages/Customize/types';

const targets = ({ get, post, put, del }: HTTPFunctions) => ({
  getTargets: () => get<CustomizedTargetResponse>('targets/'),
  addTarget: (target: CustomizedTarget) => post<CustomizedTargetWithId>('targets/', {...target}),
  updateTarget: (target: CustomizedTargetWithId) => put<CustomizedTargetWithId>(`targets/${target.id}`, {...target}),
  delTarget: (id: number) => del<BasicSuccessResponse>(`targets/${id}`),
  getTargetUsersToShare: (id: number) => get<ProfileUsersToShareResponse>(`targets/share/${id}`),
  setTargetUsersToShare: (id: number, data: SetTargetUsersToShareRequest) => put<BasicSuccessResponse>(`targets/share/${id}`, data)
});

export default targets;
